import httpService from "./httpService";

export default {
  getSignatureInfo(docId) {
    return httpService.get("signatureInfo/"+docId);
  },
  getSignatureInfoByAttachmentId(attachmentId) {
    return httpService.get("signatureInfo/getSignatureInfoByAttachmentId/"+attachmentId);
  }
}



// WEBPACK FOOTER //
// ./src/services/signatureInfoService.js